import gql from 'graphql-tag';

export const CREATE_STRIPE_ONBOARDING_LINK = gql`
  mutation CreateStripeOnboardingLink($account_id: Int!) {
    createStripeOnboardingLink(account_id: $account_id) {
      url
    }
  }
`;
